//@ts-check

class DocumentsSelector {
	constructor($timeout, $interval, $rootScope, $templateCache) {
		this.scope = {
			twoColumns: '=?',
			selectEvent: '&',
			targetSelector: '@',
			columnClassName: '@',
			selectedPayment: '=',
			containerClassName: '@',
			selectedChangedEvent: '@?'
		};

		this.$timeout = $timeout;
		this.$interval = $interval;
		this.$rootScope = $rootScope;
		this.$templateCache = $templateCache;
		this.template = this.htmlViewTemplate;
		this.link = this.documentsSelectorLink;
	}

	init(scope, element) {
		this.scopeReference = scope;
		this.$scopeReference = scope;
		this.$element = angular.element(element);

		this._registerEventHandlers();
	}

	previewDocument(index) {
		let __this;

		let scope = this.$scopeReference.$parent;
		while (!__this) {
			if ('previewDocument' in scope) {
				__this = scope;
			}

			scope = scope.$parent;
		}

		__this.$scopeReference.selectedPayment.Attachments.forEach((attachment) => {
			attachment.isSelected = false;
		});

		if (index > -1) {
			__this.$scopeReference.selectEvent({ index });
			__this.$scopeReference.selectedPayment.Attachments[index].isSelected = true;
		}
	}

	documentsSelectorLink(scope, element, attrs) {
		scope.previewDocument = this.previewDocument;

		this.init(scope, element);
	}

	get htmlViewTemplate() {
		const template = this.$templateCache.get('templates/documents-selector-tmpl.html');
		return template;
	}

	_refreshEQCSS() {
		this.$rootScope.$eval(() => {
			this.$timeout(() => {
				EQCSS.apply();
			}, 120);
		});
	}

	_registerEventHandlers() {
		const $modal = angular.element(this.$element.closest('.modal')[0]);
		$modal.on('shown.bs.modal', () => {
			this._refreshEQCSS();

			if (
				!!this.scopeReference.selectedPayment.Attachments &&
				this.scopeReference.selectedPayment.Attachments.length > 0
			) {
				this.scopeReference.selectedPayment.Attachments[0].isSelected = true;
			}
		});

		$modal.on('hidden.bs.modal', () => {
			this.scopeReference.selectedPayment.Attachments.forEach((attachment) => {
				attachment.isSelected = false;
			});

			this.scopeReference.selectedPayment.Attachments.forEach(() => {
				this.$timeout(() => this.$rootScope.$broadcast('documents-scroller-adjust', { dir: 'left' }), 250);
			});
		});

		this.scopeReference.$watch(
			'selectedPayment',
			(newValue, oldValue) => {
				if (this.scopeReference.selectedPayment && newValue) {
					const { Attachments: attachments } = this.scopeReference.selectedPayment || newValue;

					if (!!!oldValue || this.scopeReference.selectedPayment.PaymentId !== oldValue.PaymentId) {
						attachments[0].isSelected = true;
						this.$rootScope.$broadcast('noOfDocumentsChanged', { noOfDocuments: attachments.length });
					}
				}
			},
			true
		);
	}
}

export default /* @ngInject */ ($timeout, $interval, $rootScope, $templateCache) =>
	new DocumentsSelector($timeout, $interval, $rootScope, $templateCache);
